var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "error-page" }, [
    _c("div", { staticClass: "logo" }),
    _c("div", { staticClass: "error-wrapper" }, [
      _c("div", { staticClass: "img" }),
      _c("h1", [_vm._v("Not Found")]),
      _c("p", [_vm._v("The requested URL was not found on this server.")]),
      _c("button", { on: { click: _vm.goBack } }, [
        _vm._v("Back to Previous Page"),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }